namespace $.$$ {

	const articles: Record<string, { title: string; text: string }> = {

		about: {
			title: 'О проекте Blitz Quiz',
			text: [
				'# Что такое Blitz Quiz?',
				'',
				'**Blitz Quiz** — это open-source приложение для проведения реалтайм квизов на митапах, конференциях и корпоративных мероприятиях. Думайте о нём как о Kahoot, но без подписок, полностью кастомизируемом и с открытым кодом.',
				'',
				'## Как это работает',
				'',
				'Ведущий создаёт квиз с вопросами, запускает игровую сессию и делится QR-кодом с аудиторией. Участники сканируют код со своих телефонов и сразу попадают в лобби — никаких регистраций и скачиваний.',
				'',
				'Вопросы показываются на экране ведущего и одновременно на устройствах игроков. После каждого вопроса — динамический лидерборд с анимациями. В финале — общий рейтинг и анти-рейтинг.',
				'',
				'## Технологии',
				'',
				'- **$mol** — реактивный фреймворк для UI',
				'- **Giper Baza** — децентрализованная база данных с реалтайм синхронизацией',
				'- **GitHub Pages** — бесплатный хостинг',
				'- **Tauri** — десктоп приложение (Windows, macOS, Linux)',
				'',
				'## Зачем ещё один квиз?',
				'',
				'Большинство квиз-платформ требуют подписку, ограничивают число участников или не работают без интернета. Blitz Quiz работает через P2P синхронизацию Giper Baza — данные передаются напрямую между устройствами. Это значит минимальную задержку и работу даже в нестабильных сетях.',
				'',
				'Кроме того, весь код открыт — вы можете форкнуть проект и адаптировать под свои нужды.',
			].join('\n'),
		},

		guide: {
			title: 'Как создать квиз за 5 минут',
			text: [
				'# Пошаговая инструкция',
				'',
				'## 1. Откройте админку',
				'',
				'Перейдите в [Blitz Quiz](https://b-on-g.github.io/blitz/) и откройте вкладку **Admin**. Здесь вы создаёте и управляете своими квизами.',
				'',
				'## 2. Создайте квиз',
				'',
				'Нажмите **Create Quiz** — появится новый квиз с названием по умолчанию. Кликните **Edit**, чтобы перейти в редактор.',
				'',
				'## 3. Настройте параметры',
				'',
				'В редакторе задайте:',
				'- **Название** квиза',
				'- **Время на чтение** вопроса (по умолчанию 5 сек)',
				'- **Время на ответ** (по умолчанию 10 сек)',
				'- **Баллы за ответ** и **множитель скорости**',
				'',
				'## 4. Добавьте вопросы',
				'',
				'Для каждого вопроса можно выбрать тип:',
				'',
				'- **Выбор** — классические варианты ответа. Отметьте галочкой правильные.',
				'- **Текстовый ввод** — игрок сам вводит ответ. Укажите допустимые варианты через запятую (например: `Париж, Paris, париж`).',
				'',
				'К вопросам и вариантам можно прикрепить **картинки**.',
				'',
				'## 5. AI-генерация',
				'',
				'Не хотите придумывать вопросы? Разверните **AI Generate Quiz** — бот создаст квиз по вашему запросу. Или используйте **Import from JSON** для массового импорта.',
				'',
				'## 6. Запустите игру!',
				'',
				'Нажмите **Play** напротив квиза. Создастся игровая сессия с уникальной ссылкой. Покажите **QR-код** аудитории — и начинайте!',
				'',
				'## Советы',
				'',
				'- Используйте **картинки** в вопросах — это повышает вовлечение',
				'- **10 секунд** на ответ оптимально для большинства вопросов',
				'- Добавьте **шуточные варианты** — это разряжает атмосферу',
				'- Включите **музыку** через встроенное радио для атмосферы',
			].join('\n'),
		},

		features: {
			title: 'Возможности Blitz Quiz',
			text: [
				'# Ключевые фичи',
				'',
				'## Реалтайм синхронизация',
				'',
				'Все действия мгновенно отражаются на всех устройствах. Когда игрок отвечает — ведущий сразу видит прогресс. Никаких задержек и перезагрузок.',
				'',
				'## QR-код для подключения',
				'',
				'Игроки просто сканируют QR-код с экрана ведущего. Никакой регистрации, установки приложений или ввода кодов. Открыл камеру → попал в игру.',
				'',
				'## Два типа вопросов',
				'',
				'- **Выбор** — один или несколько правильных вариантов из списка',
				'- **Текстовый ввод** — свободный ответ с гибкой проверкой (учитывает регистр, пробелы, синонимы)',
				'',
				'## Картинки в вопросах',
				'',
				'Загружайте изображения к вопросам и вариантам ответа. Идеально для визуальных квизов: угадай фильм по кадру, узнай логотип, определи город по фото.',
				'',
				'## Умный подсчёт очков',
				'',
				'Баллы зависят не только от правильности, но и от **скорости** ответа. Чем быстрее — тем больше бонус. Неправильный ответ штрафуется.',
				'',
				'## Лидерборд и Анти-лидерборд',
				'',
				'После каждого вопроса — динамический **Топ-10** и **Антитоп-10**. Награда лучшему и "утешительный приз" худшему — проверено, это самая весёлая часть!',
				'',
				'## Эмодзи-реакции',
				'',
				'Игроки могут отправлять реакции (❤️ 😊 🔥 👏 💩) в любой момент игры. На финале — отдельный **Reactboard** с топ-3 по каждой реакции.',
				'',
				'## Пауза',
				'',
				'Ведущий может **поставить на паузу** в любой момент — таймер остановится и продолжится с того же места.',
				'',
				'## Обратный отсчёт',
				'',
				'На последних 3 секундах ответа — **звуковой отсчёт 3-2-1** для драматичности.',
				'',
				'## AI-генератор квизов',
				'',
				'Встроенный бот создаст квиз по любой теме: от поп-культуры до профессиональных знаний. Просто опишите тему — получите готовый набор вопросов.',
				'',
				'## Импорт из JSON',
				'',
				'Подготовьте квиз в JSON-формате и загрузите одной кнопкой. Удобно для интеграции с другими системами или массовой подготовки контента.',
				'',
				'## Темная и светлая темы',
				'',
				'Автоматическое переключение темы в зависимости от системных настроек. Или вручную — кнопка в панели инструментов.',
				'',
				'## Десктоп-приложение',
				'',
				'Благодаря **Tauri** Blitz Quiz доступен как нативное приложение для Windows, macOS и Linux. Быстрый запуск, минимальное потребление ресурсов.',
				'',
				'---',
				'',
				'Попробуйте сами: [Открыть Blitz Quiz](https://b-on-g.github.io/blitz/)',
			].join('\n'),
		},

		collab: {
			title: 'Коллаборативное редактирование из коробки',
			text: [
				'# Совместное редактирование квизов',
				'',
				'Blitz Quiz построен на **Giper Baza** — децентрализованной базе данных с реалтайм синхронизацией. Это значит, что коллаборативное редактирование работает из коробки, без единой строчки дополнительного кода.',
				'',
				'## Как это работает',
				'',
				'Каждый квиз живёт в своём **land** — изолированном пространстве данных. Ссылка на квиз из админки содержит идентификатор этого land. Любой, у кого есть ссылка, может открыть квиз и редактировать его в реальном времени.',
				'',
				'Скопируйте ссылку из админки, отправьте коллеге — и редактируйте квиз одновременно. Все изменения мгновенно синхронизируются через P2P.',
				'',
				'## Сценарии использования',
				'',
				'- **Подготовка квиза командой** — каждый добавляет вопросы по своей теме',
				'- **Ревью контента** — коллега открывает ссылку и правит формулировки',
				'- **Живое редактирование** — добавляйте вопросы прямо во время мероприятия',
				'',
				'## Никаких настроек',
				'',
				'Не нужно создавать команды, приглашать пользователей или настраивать права доступа. Просто поделитесь ссылкой — и работайте вместе. Это P2P-синхронизация Giper Baza в действии.',
			].join('\n'),
		},

	}

	export class $bog_blitz_blog_page extends $.$bog_blitz_blog_page {

		article_title() {
			return articles[this.slug()]?.title ?? 'Страница не найдена'
		}

		article_text() {
			return articles[this.slug()]?.text ?? 'Такой статьи пока нет.'
		}
	}
}
